import type { WorkflowContent } from 'providers/ProgressiveOnboarding/types';
import { PRODUCT_AREAS } from 'utils/events';

import {
  ACTIVATE_AUTOMATION_MANAGED_STEP_CONTENT,
  ACTIVATE_CAMPAIGN_MANAGED_STEP_CONTENT,
  ACTIVATE_POPUP_MANAGED_STEP_CONTENT,
  IMPORT_SUBSCRIBERS_MANAGED_STEP_CONTENT,
} from './appManagedSteps';
import {
  COMPLETE_COMPLIANCE_STEP_CONTENT,
  ENABLE_INTEGRATION_STEP_CONTENT,
  SAVE_BRAND_CENTER_STEP_CONTENT,
  TRY_INFINITY_TESTING_STEP_CONTENT,
} from './appSharedSteps';
import {
  ACTIVATE_AUTOMATION_TOUCHLESS_STEP_CONTENT,
  ACTIVATE_POPUP_TOUCHLESS_STEP_CONTENT,
  CAMPAIGN_SENT_TOUCHLESS_STEP_CONTENT,
  IMPORT_SUBSCRIBERS_TOUCHLESS_STEP_CONTENT,
} from './appTouchlessSteps';
import {
  PS_APP_PROG_ONBOARDING_MANAGED_FEATURE_KEY,
  PS_APP_PROG_ONBOARDING_TOUCHLESS_FEATURE_KEY,
  SHOPPER_FEATURE_KEY,
} from './constants';
import { SHOPPER_STEPS } from './shopperSteps';

export const ONBOARDING_CONTENT: Record<string, WorkflowContent> = {
  [SHOPPER_FEATURE_KEY]: {
    key: SHOPPER_FEATURE_KEY,
    title: 'Shopper Setup',
    subtitle: "Your brand's always-on AI shopping assistant.",
    icon: 'ShoppingBag',
    splashScreen: true,
    steps: SHOPPER_STEPS,
    productArea: PRODUCT_AREAS.SHOPPER,
  },
  [PS_APP_PROG_ONBOARDING_TOUCHLESS_FEATURE_KEY]: {
    key: PS_APP_PROG_ONBOARDING_TOUCHLESS_FEATURE_KEY,
    title: 'Getting Started',
    subtitle: '',
    icon: 'Rocket',
    callout: {
      title: 'Migrating from another platform?',
      content:
        'Do not activate Automations, Campaigns, and Popups or import your subscribers until all list growth tools and messaging are deactivated on your previous platform to prevent duplicate messaging.',
      icon: 'Briefcase',
    },
    steps: {
      ...COMPLETE_COMPLIANCE_STEP_CONTENT,
      ...ACTIVATE_AUTOMATION_TOUCHLESS_STEP_CONTENT,
      ...CAMPAIGN_SENT_TOUCHLESS_STEP_CONTENT,
      ...ACTIVATE_POPUP_TOUCHLESS_STEP_CONTENT,
      ...ENABLE_INTEGRATION_STEP_CONTENT,
      ...SAVE_BRAND_CENTER_STEP_CONTENT,
      ...TRY_INFINITY_TESTING_STEP_CONTENT,
      ...IMPORT_SUBSCRIBERS_TOUCHLESS_STEP_CONTENT,
    },
    productArea: PRODUCT_AREAS.PROGRESSIVE_ONBOARDING,
  },
  [PS_APP_PROG_ONBOARDING_MANAGED_FEATURE_KEY]: {
    key: PS_APP_PROG_ONBOARDING_MANAGED_FEATURE_KEY,
    title: 'Getting Started',
    subtitle: '',
    icon: 'Rocket',
    steps: {
      ...COMPLETE_COMPLIANCE_STEP_CONTENT,
      ...ENABLE_INTEGRATION_STEP_CONTENT,
      ...ACTIVATE_AUTOMATION_MANAGED_STEP_CONTENT,
      ...SAVE_BRAND_CENTER_STEP_CONTENT,
      ...TRY_INFINITY_TESTING_STEP_CONTENT,
      ...ACTIVATE_CAMPAIGN_MANAGED_STEP_CONTENT,
      ...ACTIVATE_POPUP_MANAGED_STEP_CONTENT,
      ...IMPORT_SUBSCRIBERS_MANAGED_STEP_CONTENT,
    },
    productArea: PRODUCT_AREAS.PROGRESSIVE_ONBOARDING,
  },
};
